import axios from './HTTP'

export default {
  send ({ sendMsg, sendToNumber }) {
    return axios
      .post('/api/sms/send.json', { sendMsg, sendToNumber })
      .then(response => {
        return response.data
      }).catch((e) => {
        throw e
      })
  },

}
